import { Button } from '@mantine/core';

export default Button.extend({
	defaultProps: {
		radius: 'xl'
	}
});
